export const MANUFACTURER_TYPES = {
  XGD: 'XGD',
  PAX: 'PAX',
  SPRD: 'sprd',
  LEPHONE: 'lephone',
  QUALCOMM: 'QUALCOMM',
  CASTLES: 'Castles',
};
